var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34925 0.25H4.65484V1.10841H1.77845V3.35181H0.920044V0.679204C0.920044 0.442962 1.11301 0.25 1.34925 0.25ZM4.1517 3.17689H5.64129V14.8231H4.1517V3.17689ZM13.4373 3.17689H14.5013V14.8231H13.4373V3.17689ZM11.376 3.17689H12.1731V14.8231H11.376V3.17689ZM6.90546 3.17689H7.35811V14.8231H6.90546V3.17689ZM18.5192 3.17689H19.8483V14.8231H18.5192V3.17689ZM15.7655 3.17689H17.2551V14.8231H15.7655V3.17689ZM8.62228 3.17689H10.1119V14.8231H8.62228V3.17689ZM1.77845 14.6482V16.8916H4.65484V17.75H1.34925C1.11301 17.75 0.920044 17.5588 0.920044 17.3208V14.6482H1.77845ZM19.567 0.25H22.6508C22.887 0.25 23.08 0.442962 23.08 0.679204V3.35181H22.2216V1.10841H19.567V0.25ZM23.08 14.6482V17.3208C23.08 17.557 22.887 17.75 22.6508 17.75H19.567V16.8916H22.2216V14.6482H23.08Z",
    fill: "#6576FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeV2);
export default __webpack_public_path__ + "static/media/Barcode_v2.e572da68.svg";
export { ForwardRef as ReactComponent };